import { regexEmail } from 'mailup-react-helpers'

import {
  DateFormatEnum,
  DateMatchEnum,
  DatesDetailsTypeEnum,
  DatesTypeEnum,
  EmailMatchEnum,
  EngagementMatchEnum,
  EngagementScoreEnum,
  NumericFormatEnum,
  SpecTypeEnum,
  TextMatchEnum,
} from 'Providers/BeFiltersApiProvider'
// import { retentionDays } from '../config/config'

export const dateFormatsRe = {
  [DateFormatEnum.DateFormat1.name]:
    /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/\d{4}$/,
  [DateFormatEnum.DateFormat2.name]:
    /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])$/,
  [DateFormatEnum.DateFormat3.name]:
    /^(0[1-9]|1[012])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/,
  [DateFormatEnum.DateFormat4.name]:
    /^(0[1-9]|1[012])\/(0[1-9]|[12][0-9]|3[01])$/,
  [DateFormatEnum.DateFormat5.name]:
    /^\d{4}\/(0[1-9]|1[012])\/(0[1-9]|[12][0-9]|3[01])$/,
  [DateFormatEnum.DateFormat6.name]:
    /^\d{4}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])$/,
  [DateFormatEnum.DateFormat7.name]:
    /^(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])$/,
  [DateFormatEnum.DateFormat8.name]:
    /^\d{4}[\\-](0?[1-9]|1[012])[\\-](0[1-9]|[12][0-9]|3[01])$/,
}

export const integerFormatRe = /^[-+]?\d{1,15}$/
export const positiveIntegerFormatRe = /^\d+$/
export const decimalFormatRe =
  /^-?(?:\d+|\d{1,3}(?:[\s,]\d{3})+)(?:[.]\d{1,2})?$/

export const validateCondition = (
  condition,
  isMultiList,
  accountDataRetention
) => {
  const { Spec } = condition
  const retentionLimit = getRetentionLimit(condition, accountDataRetention)
  switch (condition.SpecType) {
    case SpecTypeEnum.GroupSpec.name:
      return validateGroupSpec(Spec, isMultiList)
    case SpecTypeEnum.TextSpec.name:
      return validateTextSpec(Spec)
    case SpecTypeEnum.NumericSpec.name:
      return validateNumericSpec(Spec)
    case SpecTypeEnum.DateSpec.name:
      return validateDateSpec(Spec)
    case SpecTypeEnum.DateTimeSpec.name:
      return validateDateTimeSpec(Spec)
    case SpecTypeEnum.EmailSpec.name:
      return validateEmailSpec(Spec, isMultiList, retentionLimit)
    case SpecTypeEnum.SmsSpec.name:
      return validateSmsSpec(Spec, isMultiList, retentionLimit)
    case SpecTypeEnum.SubscriptionSpec.name:
      return validateSubscriptionSpec(Spec)
    default:
      return false
  }
}

export const validateGroupSpec = (Spec, isMultiList) => {
  if (isMultiList) {
    return false
  }
  return Spec.GroupMatchOperator.length > 0 && Spec.Values.length > 0
}

export const validateTextSpec = (Spec) => {
  return (
    Spec.Identifier.length > 0 &&
    Spec.TextMatchOperator.length > 0 &&
    Array.isArray(Spec.Values) &&
    ((Spec.Values.length > 0 && !isEmpty(Spec.Values[0])) ||
      Spec.TextMatchOperator === TextMatchEnum.TextNullEmpty.name ||
      Spec.TextMatchOperator === TextMatchEnum.TextNotNullNotEmpty.name)
  )
}

export const validateNumericValue = (Spec) => {
  const asString = `${Spec.Values[0]}`
  //  const n = Number(asString)
  const rawDigits = asString.replace(/\D+/g, '')

  switch (Spec.Format) {
    case NumericFormatEnum.Decimal.name:
      return decimalFormatRe.test(asString) && rawDigits.length <= 7
    case NumericFormatEnum.Integer.name:
      return integerFormatRe.test(asString) && rawDigits.length <= 7 // Number.isSafeInteger(n)
    default:
      return false
  }
}

export const validateNumericSpec = (Spec) => {
  return (
    Spec.Identifier.length > 0 &&
    Spec.Format.length > 0 &&
    Spec.NumericMatchOperator.length > 0 &&
    Spec.Values.length === 1 &&
    validateNumericValue(Spec)
  )
}

export const validateDateValue = (Spec) => {
  switch (Spec.DateMatchOperator) {
    case DateMatchEnum.PlusXdaysEqualsToToday.name:
    case DateMatchEnum.MinusXdaysEqualsToToday.name:
    case DateMatchEnum.PlusXDaysEarlierThanToday.name:
    case DateMatchEnum.PlusXdaysLaterThanToday.name:
    case DateMatchEnum.MinusXdaysEarlierThanToday.name:
    case DateMatchEnum.MinusXdaysLaterThanToday.name:
      return (
        Spec.Values.length === 1 &&
        Spec.Values[0] !== null &&
        integerFormatRe.test(Spec.Values[0])
      )
    case DateMatchEnum.EqualTo.name:
    case DateMatchEnum.Before.name:
    case DateMatchEnum.After.name:
      const re = dateFormatsRe[Spec.Format]
      return (
        Spec.Values.length === 1 &&
        Spec.Values[0] !== null &&
        re.test(Spec.Values[0])
      )
    case DateMatchEnum.EqualToToday.name:
      return true
    default:
      return false
  }
}

export const validateDateSpec = (Spec) => {
  return (
    Spec.Identifier.length > 0 &&
    Spec.Format.length > 0 &&
    Spec.DateMatchOperator.length > 0 &&
    Array.isArray(Spec.Values) &&
    validateDateValue(Spec)
  )
}

export const validateDateTimeValue = (Spec) => {
  return integerFormatRe.test(Spec.Values[0])
}

export const validateDateTimeSpec = (Spec) => {
  return (
    Spec.Identifier.length > 0 &&
    Spec.Format.length > 0 &&
    Spec.DateTimeMatchOperator.length > 0 &&
    Array.isArray(Spec.Values) &&
    Spec.Values.length === 1 &&
    validateDateTimeValue(Spec)
  )
}

export const validateEmailSpec = (Spec, isMultiList, retentionLimit) => {
  return (
    !isEmpty(Spec.EmailMatchOperator) &&
    validateActivityMessages(Spec, isMultiList) &&
    validateActivityDates(Spec) &&
    validateActivityDateValue(Spec, retentionLimit) &&
    validateActivityDateRetentionValue(Spec, retentionLimit) &&
    validateActivityTag(Spec, isMultiList)
  )
}

export const validateSmsSpec = (Spec, isMultiList, retentionLimit) => {
  return (
    !isEmpty(Spec.SmsMatchOperator) &&
    validateActivityMessages(Spec, isMultiList) &&
    validateActivityDates(Spec) &&
    validateActivityDateValue(Spec, retentionLimit) &&
    validateActivityDateRetentionValue(Spec, retentionLimit) &&
    validateActivityTag(Spec, isMultiList)
  )
}

export const validateActivityTag = (Spec, isMultiList) => {
  if (isMultiList) {
    if (!Array.isArray(Spec.Tags)) return true
    else if (Spec.Tags.length === 0) return true
    else return false
  } else {
    return true
  }
}

export const validateSubscriptionSpec = (Spec) => {
  return (
    !isEmpty(Spec.SubscriptionMatchOperator) &&
    validateActivityDates(Spec) &&
    validateActivityDateValue(Spec)
  )
}

export const validateActivityMessages = (Spec, isMultiList) => {
  return (
    Array.isArray(Spec.Messages) &&
    Spec.Messages.length === 1 &&
    !isEmpty(Spec.Messages[0]) &&
    ((isMultiList && Spec.Messages[0] <= 0) || !isMultiList)
  )
}

export const validateActivityDates = (Spec) => {
  switch (Spec.Dates.Type) {
    case DatesTypeEnum.DateRangeDetails.name:
      return (
        (Spec.Dates.Details.From === null && Spec.Dates.Details.To === null) ||
        !isEmpty(Spec.Dates.Details.From) ||
        !isEmpty(Spec.Dates.Details.To)
      )
    default:
      return true
  }
}

export const validateActivityDateValue = (Spec) => {
  switch (Spec.Dates.Type) {
    case DatesTypeEnum.DaysDetails.name:
    case DatesTypeEnum.HoursDetails.name:
      return (
        !isEmpty(Spec.Dates.Details.Type) &&
        !isEmpty(Spec.Dates.Details.Value) &&
        positiveIntegerFormatRe.test(Spec.Dates.Details.Value)
      )
    default:
      return true
  }
}

export const validateActivityDateRetentionValue = (Spec, retentionLimit) => {
  if (typeof retentionLimit === 'undefined') {
    return true
  } else {
    return Number(Spec.Dates.Details.Value) <= retentionLimit
  }
}

export const validateEngagementSpec = (Spec) => {
  return (
    Spec.EngagementMatchOperator === EngagementMatchEnum.EqualTo.name &&
    Array.isArray(Spec.Values) &&
    Spec.Values.length === 1 &&
    EngagementScoreEnum.enumValues
      .map((e) => e.ordinal)
      .includes(Spec.Values[0])
  )
}

export const isEmpty = (value) =>
  typeof value === 'undefined' || value === null || value === ''

export const getRetentionLimit = (condition, accountDataRetention) => {
  switch (condition.SpecType) {
    case SpecTypeEnum.EmailSpec.name:
      return getEmailDataRetention(condition.Spec, accountDataRetention)

    case SpecTypeEnum.SmsSpec.name:
      return getSmsDataRetention(condition.Spec, accountDataRetention)

    default:
      return undefined
  }
}

export const getEmailDataRetention = (Spec, accountDataRetention) => {
  switch (Spec.EmailMatchOperator) {
    case EmailMatchEnum.EmailNotSent.name:
    case EmailMatchEnum.EmailSent.name:
    case EmailMatchEnum.EmailSuccessfullySent.name:
      //  eventi di Send
      switch (Spec.Dates.Type) {
        case DatesTypeEnum.DaysDetails.name:
          switch (Spec.Dates.Details.Type) {
            case DatesDetailsTypeEnum.Exactly.name:
              //  Esattamente..giorni..
              return accountDataRetention - 1
            case DatesDetailsTypeEnum.Last.name:
              //  Ultimi..giorni..
              return accountDataRetention
          }
          break
        case DatesTypeEnum.HoursDetails.name:
          switch (Spec.Dates.Details.Type) {
            case DatesDetailsTypeEnum.Exactly.name:
              //  Esattamente..ore..
              return accountDataRetention * 24 - 1
            case DatesDetailsTypeEnum.Last.name:
              //  Ultime..ore..
              return accountDataRetention * 24
          }
          break

        default:
          //  su range non consideriamo data retention
          return undefined
      }
      break

    default:
      //  altri eventi
      switch (Spec.Dates.Type) {
        case DatesTypeEnum.DaysDetails.name:
          switch (Spec.Dates.Details.Type) {
            case DatesDetailsTypeEnum.Exactly.name:
              //  Esattamente..giorni..
              return accountDataRetention - 1
            case DatesDetailsTypeEnum.Last.name:
              //  Ultimi..giorni..
              return accountDataRetention
          }
          break
        case DatesTypeEnum.HoursDetails.name:
          switch (Spec.Dates.Details.Type) {
            case DatesDetailsTypeEnum.Exactly.name:
              //  Esattamente..ore..
              return accountDataRetention * 24 - 1
            case DatesDetailsTypeEnum.Last.name:
              //  Ultime..ore..
              return accountDataRetention * 24
          }
          break

        default:
          //  su range non consideriamo data retention
          return undefined
      }
  }
}

export const getSmsDataRetention = (Spec, accountDataRetention) => {
  //  per SMS gli eventi sono tutti allineati alla data retention di console
  switch (Spec.Dates.Type) {
    case DatesTypeEnum.DaysDetails.name:
      switch (Spec.Dates.Details.Type) {
        case DatesDetailsTypeEnum.Exactly.name:
          //  Esattamente..giorni..
          return accountDataRetention - 1
        case DatesDetailsTypeEnum.Last.name:
          //  Ultimi..giorni..
          return accountDataRetention
      }
      break
    case DatesTypeEnum.HoursDetails.name:
      switch (Spec.Dates.Details.Type) {
        case DatesDetailsTypeEnum.Exactly.name:
          //  Esattamente..ore..
          return accountDataRetention * 24 - 1
        case DatesDetailsTypeEnum.Last.name:
          //  Ultime..ore..
          return accountDataRetention * 24
      }
      break

    default:
      //  su range non consideriamo data retention
      return undefined
  }
}

export const isNumeric = (n) => {
  return !isNaN(parseFloat(n)) && isFinite(n)
}

export const isUnsignedInteger = (s) => {
  return s ? `${s}`.match(/^\d+$/) !== null : false
}
export const isValidEmail = (s) => regexEmail.test(s)
